import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box, Stack } from "@mui/material";
import CommonPages from "./CommonPages";
import ArticlePages from "./ArticlePages";
import MerchantCategories from "./MerchantCategories";
import ProductSections from "./ProductSections";
import ProductCategoris from "./ProductCategories";
import Products from "./Products";

const modalRoot = document.querySelector("#image-picker");

function PageDialog({ title, multiple, visible, onSelect, onCancel }) {
  const [open, setOpen] = React.useState(visible);

  const [value, setValue] = React.useState(0);

  const handleClose = () => {
    setOpen(false);
    onCancel();
  };

  const handleSelect = (v) => {
    setOpen(false);
    onSelect(v);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="unset">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack direction="row">
          <Tabs value={value} orientation="vertical" onChange={(e, newValue) => {
            setValue(newValue)
          }} variant="scrollable" scrollButtons={false}>
            <Tab label="常规页面" />
            <Tab label="商户分类" />
            <Tab label="商品专区" />
            <Tab label="商品分类" />
            <Tab label="普通商品" />
            <Tab label="文章" />
          </Tabs>
          <Stack sx={{width: 800, height: 500, maxHeight: 500, overflow: 'hidden'}} paddingX={3}>
            {value == 0 && <CommonPages onSelect={handleSelect} />}
            {value == 1 && <MerchantCategories onSelect={handleSelect} />}
            {value == 2 && <ProductSections onSelect={handleSelect} />}
            {value == 3 && <ProductCategoris onSelect={handleSelect} />}
            {value == 4 && <Products onSelect={handleSelect} />}
            {value == 5 && <ArticlePages onSelect={handleSelect} />}
          </Stack>
        </Stack>
        
      </DialogContent>

      {/* {!multiple ? null : (
        <DialogActions>
          <Button onClick={handleClose}>取消</Button>
          <Button onClick={handleConfirm}>确定</Button>
        </DialogActions>
      )} */}
    </Dialog>
  );
}

const PagePicker = ({ title = "选择链接", multiple = false, onSelect = () => {}, onCancel = () => {} }) => {
  ReactDOM.unmountComponentAtNode(modalRoot);
  ReactDOM.render(<PageDialog visible={true} onCancel={onCancel} onSelect={onSelect} title={title} multiple={multiple} />, modalRoot);
};

export default PagePicker;
